import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../../language/vn';
import {SoVanThuService} from '../../../../service/info/service-sovanthu';
import { FormBuilder} from '@angular/forms';
import {SoVanThu} from '../../../../models/info/sovanthu';
import { ToastrService } from 'ngx-toastr';
import {BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../../../environments/environment';
import {EditSoVanThuComponent} from '../../sovanthu/edit.component';
import {NhomVanBanDi} from '../../../../models/vanbandi/nhomvanbandi';
import {NhomVanBanDiService} from '../../../../service/vanbandi/service-nhomvanbandi';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {EditNhomVanBanDiComponent} from './edit.component';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';

@Component({
  templateUrl: './so.component.html'

})export class SVTVanBanDiComponent implements OnInit {

  public language = language;
  public dataList: NhomVanBanDi[];
  public keyword: string = '';
  public permissionView: boolean = false;
  public permissionAdd: boolean = false;
  public permissionUpdate: boolean = false;
  public permissionDelete: boolean = false;
  private moduleName:  string = 'egov.info.vanbandi.qlso';
  constructor( public nhomVanBanDiService: NhomVanBanDiService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public rolePermissionService: RolePermissionService


  ) {

  }
  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex( y => y.action === environment.view) !== -1;
      if(this.permissionView === true)
        this.search(this.keyword);
      else
        this.rolePermissionService.redirectAccesDenied();
      this.permissionAdd = x.findIndex( y => y.action === environment.add) !== -1;
      this.permissionUpdate = x.findIndex( y => y.action === environment.update) !== -1;
      this.permissionDelete = x.findIndex( y => y.action === environment.delete) !== -1;
    });
  }
  edit(id: number) {

    const modalEdit = this.bsModalService.show(EditNhomVanBanDiComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditNhomVanBanDiComponent>modalEdit.content).edit(
      id
    );
    (<EditNhomVanBanDiComponent>modalEdit.content).onClose.subscribe(result => {
      this.search(this.keyword);
    });

  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.nhomVanBanDiService.delete(id).subscribe({
          next: () => {
            this.toastr.success(language.delete_success_record, language.message);
            this.search(this.keyword);


          },
          error: error => {
            this.toastr.error(language.error, language.message);
          }
        });
      }
    });
  }
  search(keyword)
  {
    this.keyword = keyword;
    this.nhomVanBanDiService.findByKeyword(keyword).subscribe(dataList => this.dataList = dataList);

  }




}
